
<app-table
module="doctemplates"
pageTitle="Elenco templates"
newRecordUrl="doctemplates/doctemplate-edit/new"
editRecordUrl="doctemplates/doctemplate-edit/update/"
deleteRecordUrl="app/doctemplate_delete"
listUrl="app/doctemplates_listall"></app-table>
	